import { render, staticRenderFns } from "./ImportPage.vue?vue&type=template&id=0f1700b2&scoped=true&"
import script from "./ImportPage.vue?vue&type=script&lang=js&"
export * from "./ImportPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f1700b2",
  null
  
)

export default component.exports